import { createFileRoute } from '@tanstack/react-router';

import { HomePage } from '../pages/HomePage';
import { dashboardRouteSearchSchema } from '../features/dashboard/dashboardRouteSearch';

export const Route = createFileRoute('/')({
  validateSearch: dashboardRouteSearchSchema,
  component: HomePage,
});
